// Coverage rules enforced by the backend (TraitTarificationsValidator /
// FromRequestManualTarificationFactory):
// - basic   → DEATH only
// - premium → DEATH + DISABILITY with the SAME capital
// - eg      → DEATH + SERIOUS_ILLNESS
// - multi   → DEATH plus any combination (per-trait capital)
export const MANUAL_TARIFICATION_COVERAGES = [
  "premium",
  "basic",
  "eg",
  "multi",
] as const;

export type ManualTarificationCoverage =
  (typeof MANUAL_TARIFICATION_COVERAGES)[number];

export type ManualTarificationTraitCode =
  | "DEATH"
  | "DISABILITY"
  | "SERIOUS_ILLNESS";

export type ManualTarificationTraitRow = {
  trait: ManualTarificationTraitCode;
  surcharge: number;
  extracharge: number;
  capital: number;
};

export type CreateManualTarificationPayload = {
  leadInternalId: number;
  manualTarificationCoverage: string;
  traitTarifications: ManualTarificationTraitRow[];
  manualTarificationEffectDate: string;
};

export type UpdateManualTarificationPayload = {
  manualTarificationUuid: string;
  manualTarificationCoverage: string;
  traitTarifications: ManualTarificationTraitRow[];
  manualTarificationEffectDate: string;
};

export type ManualTarificationTraitDetail = {
  surcharge: number;
  extracharge: number;
  capital: number;
  effectDate: string;
};

// Shape returned by GET .../manual-tarification.
export type ExistingManualTarification = {
  exists: boolean;
  tarificationUuid?: string | null;
  coverage?: string | null;
  isDowngraded?: boolean;
  tarifications?: {
    deceaseSurcharge?: number;
    deceaseExtracharge?: number;
    disabilitySurcharge?: number;
    disabilityExtracharge?: number;
    capital?: number;
    effectDate?: string;
    byTrait?: Record<string, ManualTarificationTraitDetail>;
  };
};
